import { render, staticRenderFns } from "./MarketNewsFields.vue?vue&type=template&id=371d931b"
import script from "./MarketNewsFields.vue?vue&type=script&lang=js"
export * from "./MarketNewsFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports